var _defineProperty = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _objectSpread = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");

var _slicedToArray = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _toConsumableArray = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _require = require('@netlify/open-api'),
    paths = _require.paths;

var omit = require('omit.js').default; // Retrieve all OpenAPI operations


var getOperations = function getOperations() {
  var _ref;

  // TODO: switch to Array.flat() once we drop support for Node.js < 11.0.0
  // eslint-disable-next-line unicorn/prefer-spread
  return (_ref = []).concat.apply(_ref, _toConsumableArray(Object.entries(paths).map(function (_ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
        path = _ref3[0],
        pathItem = _ref3[1];

    var operations = omit(pathItem, ['parameters']);
    return Object.entries(operations).map(function (_ref4) {
      var _ref5 = _slicedToArray(_ref4, 2),
          method = _ref5[0],
          operation = _ref5[1];

      var parameters = getParameters(pathItem.parameters, operation.parameters);
      return _objectSpread({}, operation, {
        verb: method,
        path: path,
        parameters: parameters
      });
    });
  })));
};

var getParameters = function getParameters() {
  var pathParameters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var operationParameters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var parameters = [].concat(_toConsumableArray(pathParameters), _toConsumableArray(operationParameters));
  return parameters.reduce(addParameter, {
    path: {},
    query: {},
    body: {}
  });
};

var addParameter = function addParameter(parameters, param) {
  return _objectSpread({}, parameters, _defineProperty({}, param.in, _objectSpread({}, parameters[param.in], _defineProperty({}, param.name, param))));
};

module.exports = {
  getOperations: getOperations
};